import "../../design/main-style.scss";
import React, {FunctionComponent, useEffect, useMemo} from "react";
import {Footer, FooterProps} from "../footer";
import {Header} from "../header";
import {getCookie} from "@klear/common-utils";

interface StrapiLayoutProps {
    footerProps: FooterProps;
    requireLogin?: boolean;
}

export const StrapiLayout: FunctionComponent<StrapiLayoutProps> = props => {
    const {footerProps, requireLogin ,children} = props;

    const userConnected = useMemo( () => !!getCookie('klear_gatsby') ,[typeof window]);

    useEffect(() => {
        if (requireLogin && typeof window !== "undefined" && window.document && !userConnected) {
            window.location.replace(`/sign-in${window.location.pathname ? `?redirect_to=${window.location.pathname}` : ''}`);
        }
    },[typeof window]);

    if (requireLogin && !userConnected) return null;
    return (
    <>
        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.7.2/css/all.css"
              integrity="sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr"
              crossOrigin="anonymous"/>
        <link rel='stylesheet' type='text/css' href='//fonts.googleapis.com/css?family=Open+Sans:400,300,700' media='screen' />
        <link href='//fonts.googleapis.com/css?family=Raleway:500,700,300' rel='stylesheet' type='text/css' />
        <link href="https://fonts.googleapis.com/css?family=Muli:400,500,600,700,800,900,900i&display=swap" rel="stylesheet"/>
        <Header/>
        <main style={{paddingTop: `var(--header-height)`}}>
            {children}
        </main>
        <Footer {...footerProps}/>
    </>
  )
};